import { render, staticRenderFns } from "./MenuSalesReport.vue?vue&type=template&id=46e42040&"
import script from "./MenuSalesReport.vue?vue&type=script&lang=js&"
export * from "./MenuSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports